import { render, staticRenderFns } from "./suitch-soilv1.vue?vue&type=template&id=62eeb0a2&scoped=true&"
import script from "./suitch-soilv1.vue?vue&type=script&lang=js&"
export * from "./suitch-soilv1.vue?vue&type=script&lang=js&"
import style0 from "./suitch-soilv1.vue?vue&type=style&index=0&id=62eeb0a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62eeb0a2",
  null
  
)

export default component.exports